// AddNiyamavali.jsx
import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const AddNiyamavali = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [karm, setKarm] = useState("");
    const [status, setStatus] = useState("");
    const [content, setContent] = useState("");
    const [error, setError] = useState({});
    const karmOptions = [
        // { value: "", label: "-- Select Karm --" },
        { value: "karm1", label: "Karm 1" },
        { value: "karm2", label: "Karm 2" },
        { value: "karm3", label: "Karm 3" },
    ];

    const statusOptions = [
        // { value: "", label: "-- Select Status --" },
        { value: "Active", label: "Active" },
        { value: "Inactive", label: "Inactive" },
    ];
    useEffect(() => {
        if (id) {
            // Backend API मिळाल्यावर इथे डेटा फेच करायचा
            setKarm("karm1");
            setStatus("Active");
            setContent("<p>ही आधीची नियमावली आहे.</p>");
        }
    }, [id]);

    const handleSubmit = (e) => {
        e.preventDefault();
        let newError = {};
        if (!karm) newError.karm = "कृपया कर्म निवडा.";
        if (!status) newError.status = "कृपया स्टेटस निवडा.";
        if (!content.trim()) newError.content = "कृपया नियमावली भरा.";

        setError(newError);
        if (Object.keys(newError).length > 0) return;

        if (id) {
            console.log("Update:", { karm, status, content });
        } else {
            console.log("Add:", { karm, status, content });
        }

        navigate("/niyamavali");
    };

    return (
        <div className="row">
            <div className="col-xl-12">
                <div className="card">
                    <div className="card-body">
                        <div className="d-flex justify-content-end mb-3">
                            <Link to="/niyamavali">
                                <Button variant="primary">Back</Button>
                            </Link>
                        </div>

                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                {/* Karm Dropdown */}
                                <div className="col-xl-6 mb-3">
                                    <label className="form-label">
                                        Select Karm <span className="text-danger">*</span>
                                    </label>
                                    <Select
                                        value={karmOptions.find(opt => opt.value === karm)}
                                        onChange={(selectedOption) => setKarm(selectedOption.value)}
                                        options={karmOptions}
                                        placeholder="Select karm"
                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                minHeight: "50px",
                                                height: "50px",
                                            }),
                                            singleValue: (provided) => ({
                                                ...provided,
                                                lineHeight: "50px",
                                            }),
                                            dropdownIndicator: (provided) => ({
                                                ...provided,
                                                padding: "4px",
                                            }),
                                            indicatorSeparator: () => ({
                                                display: "none",
                                            }),
                                        }}
                                    // isClearable
                                    />
                                    {error.karm && (
                                        <small className="text-danger">{error.karm}</small>
                                    )}
                                </div>

                                {/* Status Dropdown */}
                                <div className="col-xl-6 mb-3">
                                    <label className="form-label">
                                        Status <span className="text-danger">*</span>
                                    </label>
                                    <Select
                                        value={statusOptions.find(opt => opt.value === status)}
                                        onChange={(selectedOption) => setStatus(selectedOption.value)}
                                        options={statusOptions}
                                        placeholder="Select Status"
                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                minHeight: "50px",
                                                height: "50px",
                                            }),
                                            singleValue: (provided) => ({
                                                ...provided,
                                                lineHeight: "50px",
                                            }),
                                            dropdownIndicator: (provided) => ({
                                                ...provided,
                                                padding: "4px",
                                            }),
                                            indicatorSeparator: () => ({
                                                display: "none",
                                            }),
                                        }}
                                    />

                                    {error.status && (
                                        <small className="text-danger">{error.status}</small>
                                    )}
                                </div>

                                {/* CKEditor */}
                                <div className="col-xl-12 mb-3">
                                    <label className="form-label">
                                        {id ? "नियमावली संपादित करा" : "नवी नियमावली जोडा"}
                                        <span className="text-danger">*</span>
                                    </label>
                                    <CKEditor
                                        editor={ClassicEditor}
                                        data={content}
                                        onChange={(event, editor) => {
                                            setContent(editor.getData());
                                        }}
                                    />
                                    {error.content && (
                                        <small className="text-danger d-block mt-2">
                                            {error.content}
                                        </small>
                                    )}
                                </div>
                            </div>

                            <button type="submit" className="btn btn-primary">
                                {id ? "Update" : "Save"}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddNiyamavali;
